module.exports = __webpack_public_path__ + "img/check.bffad7be.svg";